
export const SkeletonRow = ({ cols = 8 }) => (
    <tr className="animate-pulse">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-5 py-4">
          <div
            className="h-3.5 bg-slate-700/50 rounded-md"
            style={{ width: `${35 + Math.random() * 55}%` }}
          />
        </td>
      ))}
    </tr>
  );